import Dispatch from "nexia_mobile/flux_like/dispatch";
import { setValueAtPath } from "nexia_mobile/flux_like/store";

Dispatch.on("SHOW_SPINNER", (message = undefined) => {
  setValueAtPath("spinnerMessage", message);
  setValueAtPath("spinnerShown", true);
});

Dispatch.on("HIDE_SPINNER", () => {
  setValueAtPath("spinnerShown", false);
});

Dispatch.on("RUN_PROMISE_WITH_SPINNER", (promiseFunc, message) => {
  Dispatch("SHOW_SPINNER", message);
  const hideSpinner = () => {
    Dispatch("HIDE_SPINNER");
  };
  promiseFunc().then(hideSpinner, hideSpinner);
});



// WEBPACK FOOTER //
// ./src/flux_like/action_handlers/spinner.js